export default "https://dakcheck.solease.nl/static/media/clock.9ccaf338.svg";